import { Banner, Button, ButtonGroup } from "@shopify/polaris"
import React from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"

import stores from "@/stores"

import { formatQuotaCount } from "../../utils/currencyUtils"

interface QuotaNoticeBannerProps {
  consumeOrderCount: number
  onDismiss: () => void
  isNewPlanVersion: boolean
  planPrice: number
  isAnnually: boolean
}

const QuotaNoticeBanner: React.FC<QuotaNoticeBannerProps> = ({
  consumeOrderCount,
  onDismiss,
  isNewPlanVersion,
  planPrice,
  isAnnually,
}) => {
  const navigate = useNavigate()
  const { t } = useTranslation("dashboard", { keyPrefix: "quotaNotice" })
  const { t: commonT } = useTranslation("common")

  const count = formatQuotaCount(consumeOrderCount)

  // @ts-ignore
  const renderTranslation = (key: string) => t(key, { consumeOrderCount: count })

  const handleUpgradeNow = () => {
    stores.commonStore.setAccountSource("/dashboard")
    navigate("/billing/plans")
  }
  const handleLearnMore = () => {
    window.open("https://docs.parcelpanel.com/shopify/plan-billing/pricing/")
  }

  return (
    <Banner
      title={t("title")}
      tone="warning"
      onDismiss={onDismiss}
    >
      {isNewPlanVersion && planPrice > 0 ? (
        <>
          <p>{renderTranslation(isAnnually ? "content" : "newContent")}</p>
          <p>{t("newContent2")}</p>
        </>
      ) : (
        <>
          <p>{renderTranslation("content")}</p>
          <p>{t("content2")}</p>
        </>
      )}

      <div className={"mt-2"}>
        <ButtonGroup>
          <Button variant="primary" onClick={handleUpgradeNow}>{t("upgradeNow")}</Button>
          <Button variant={"tertiary"} onClick={handleLearnMore}>{commonT("LearnMore")}</Button>
        </ButtonGroup>
      </div>
    </Banner>
  )
}

export default QuotaNoticeBanner
